import React from 'react';

// React Router Dom
import { Link } from 'react-router-dom';

// PropTypes
import PropTypes from 'prop-types';

// Typography
import { H5 } from '../../themes/typography';

// Buttons
import { PrimaryBtn } from '../Buttons/Buttons';

// FontAwesome Icons
import { WhatsappIcon, FacebookIcon, LinkedinIcon } from '../../icons/FontAwesomeIcon';

// CSS Styles
import '../../styles/components/EventShareSection.css';

export default function EventShareSection({
    copyLinkUrl = `${window.location.href}`,
    whatsAppShareUrl = `${window.location.href}`,
    linkedInShareUrl = `${window.location.href}`,
    facebookShareUrl = `${window.location.href}`,
    copyBtn = <PrimaryBtn name="Copy" />
}) {
    return (
        <div className="event-share-details-container">
            {/* Share Event Title */}
            <H5 fontWeight={600}>Share This Event</H5>

            {/* Event Sharing Details Section */}
            <section className="event-sharing-details-section">
                {/* Event Sharing Link Section */}
                <div className="event-sharing-link-btn-container">
                    <div className="event-sharing-link">
                        <input type="text" value={copyLinkUrl} readOnly />
                    </div>

                    <div className="event-sharing-btn">{copyBtn}</div>
                </div>

                {/* Event Share Social Media Icons */}
                <div className="event-sharing-social-media-container">
                    <div className="event-sharing-social-icons">
                        <Link to={whatsAppShareUrl} target="_blank">
                            <WhatsappIcon style={{ color: '#F8A21E', fontSize: '2rem' }} />
                        </Link>
                        <Link to={linkedInShareUrl} target="_blank">
                            <LinkedinIcon style={{ color: '#F8A21E', fontSize: '2rem' }} />
                        </Link>
                        <Link to={facebookShareUrl} target="_blank">
                            <FacebookIcon style={{ color: '#F8A21E', fontSize: '2rem' }} />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}

// PropTypes Validation
EventShareSection.propTypes = {
    copyLinkUrl: PropTypes.string.isRequired,
    whatsAppShareUrl: PropTypes.string.isRequired,
    linkedInShareUrl: PropTypes.string.isRequired,
    facebookShareUrl: PropTypes.string.isRequired,
    copyBtn: PropTypes.element
};
